import {Badge, Image} from "antd";
import moment from "moment";
import React, {useMemo} from "react";
import {isEqual} from "underscore";

interface BookCoverProps {
  className?: string;
  issue?: object | null;
  preview?: boolean;
  onClick?: (issue) => void;
  text?: string;
  size?: '' | 'small' | 'large';
  style?: any;
  isTopPrice?: boolean;
}

const defaultProps: BookCoverProps = {
  className: "",
  preview: true,
};

const IMAGE_MISSING = "data:image/png;base64,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";

const BookCoverDetail = ({ className, issue, preview, onClick, text, style, size }) => {
  const isSigned = useMemo(() => {
    if(!!issue.signed_by_ids && issue.signed_by_ids !== '') return true;
    switch(issue.label_type){
      case 2: //CGC Signature Series
      case 7: //CGC Signature Series Qualified
      case 8: //CGC Signature Series Restored
      case 10: //CBCS Authentic Signature
      case 11: //CBCS Verified Signature
      case 12: //CBCS Verified Red Label (legacy)
        return true;
    }
    return false;
  }, [issue]);

  const isPreRelease = useMemo(() => {
    return issue && issue.date && moment().isBefore(issue.date);
  }, [issue]);

  const imgSrc = useMemo(() => {
    if (preview && issue && issue.full_image) return issue.full_image;
    if (issue && issue.medium_image) return issue.medium_image;
    if (issue && issue.full_image) return issue.full_image;
    if (issue && issue.image) return issue.image;
    return '/wp-content/themes/covr/assets/images/default_cover.jpg';
  }, [issue]);

  const fontSize = useMemo(() => {
    if (size === 'small') return '60%';
    return '100%';
  },[size]);

  return (
    <div className={`book-cover ratio-10-by-15 ${className}` + (onClick ? ' cursor-pointer' : '')} style={{...style, fontSize}} onClick={() => { if (onClick) onClick(issue) }}>
      <figure className="issue-border img-wrap">
        <Image preview={!onClick && preview} loading="lazy" src={imgSrc} fallback={IMAGE_MISSING} alt={issue ? issue.title : 'No image found.'} />
        {isSigned && (
            <div className="issue-label signature">
              SIGNATURE
            </div>
        )}
        <div className="issue-details">
          {isPreRelease && (
            <div className="issue-label prerelease">
              PRE-RELEASE
            </div>
          )}
          {!!text && (
            <h3 title={text} className="line-clamp-2 issue-variant-title">
              {text}
            </h3>
          )}
        </div>
      </figure>
    </div>
  );
};

const BookCover = ({ className, issue, preview, onClick, text, style, size, isTopPrice }) => {
  const bookCoverRender = useMemo(() => {
    let bookCover = (<BookCoverDetail className={className} style={style} issue={issue} preview={preview} onClick={onClick} text={text} size={size} />);

    if(isTopPrice){
      bookCover = (<Badge.Ribbon text={`TOP $`} color="#479D45" className="covr-variant-ribbon" >
        {bookCover}
      </Badge.Ribbon>)
    }

    if(issue.is_variant){
      bookCover = (<Badge.Ribbon text={`VAR`} color="#4134fe" className="covr-variant-ribbon" style={{marginTop: isTopPrice ? 30 : 0}}>
        {bookCover}
      </Badge.Ribbon>)
    }

    return bookCover;
  }, [issue, preview, onClick, text, style, size, isTopPrice]);

  return bookCoverRender;
}

BookCover.defaultProps = defaultProps;

const BookCoverMemoized = React.memo(BookCover, (prevProps, nextProps) => {
  return isEqual(prevProps.issue, nextProps.issue)
      && prevProps.className === nextProps.className
      && prevProps.preview === nextProps.preview
      && prevProps.text === nextProps.text
      && prevProps.style === nextProps.style
      && prevProps.size === nextProps.size
      && prevProps.isTopPrice === nextProps.isTopPrice;
});

export default BookCoverMemoized;
